import { withTipiContratto } from "../../tipiContratto/withTipiContratto";
import { Contratto, TipoContratto } from "../../generated";
import React, { useRef } from "react";
import OpenModalButton from "../../common/components/openModalButton";
import ContrattoForm from "./ContrattoForm";
import ContrattiActions from "../ContrattiActions";
import DatesHelper from "../../common/datesHelper";
import { Dictionary } from "../../common/AbstractStores";

const __ContrattoWidget: React.FunctionComponent<{ contratto: Contratto, tipiContratto: Dictionary<TipoContratto>; }> = ({ contratto, tipiContratto }) => {
    const modal = useRef<OpenModalButton>(null);
    const today = DatesHelper.Today();
    const expired = contratto.fineValidita < today;
    return <div className="card shadow-sm me-4" >
        <div className="card-body">
            <div>
                <span className={!expired ? "badge bg-success" : "fw-bold text-danger"}
                    style={{ textDecoration: expired ? "line-through" : undefined, fontWeight: expired ? undefined : "bold", fontSize: "1rem" }}>
                    {`Scadenza  ${DatesHelper.getReadableDateString(contratto.fineValidita)}`}
                </span>
            </div>
            <div>
                <strong className="me-1"></strong>{tipiContratto[contratto.tipoContrattoId]?.descrizione}
            </div>
        </div>
        <div className="card-footer">
            <OpenModalButton
                ref={modal}
                className="btn btn-outline-secondary ms-auto"
                modalContent={<ContrattoForm
                    contratto={contratto}
                    onCancel={() => modal.current!.close()}
                    onSubmit={
                        async x => {
                            await ContrattiActions.update(contratto);
                            modal.current?.close();
                        }
                    }
                />}
            >
                <i className="fas fa-edit" /> <span className="hidden-sm-down">Modifica</span>
            </OpenModalButton>
            <button type="button" className="btn btn-danger ms-1" onClick={() => ContrattiActions.delete(contratto)}>
                <i className="fas fa-trash" />
            </button>
        </div>
    </div>

}

export default withTipiContratto(__ContrattoWidget)(x => x.allByKey(), "tipiContratto")